// Generated from SVG to Code Figma Plugin

import type React from 'react';

export const BaseLineMotionControl = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.58333 12.5H5.83333C4.94928 12.5 4.10143 12.8512 3.47631 13.4763C2.85119 14.1014 2.5 14.9493 2.5 15.8333V17.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.01667"
    />
    <path
      d="M17.8151 13.855C18.147 13.5231 18.3335 13.0728 18.3335 12.6034C18.3335 12.1339 18.147 11.6837 17.8151 11.3517C17.4831 11.0197 17.0329 10.8333 16.5634 10.8333C16.0939 10.8333 15.6437 11.0197 15.3117 11.3517L11.9701 14.695C11.7719 14.8931 11.6269 15.1378 11.5484 15.4067L10.8509 17.7984C10.83 17.8701 10.8287 17.9461 10.8473 18.0185C10.8658 18.0908 10.9035 18.1569 10.9563 18.2097C11.0091 18.2625 11.0751 18.3001 11.1475 18.3187C11.2198 18.3372 11.2959 18.336 11.3676 18.315L13.7592 17.6175C14.0281 17.539 14.2729 17.394 14.4709 17.1959L17.8151 13.855Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.01667"
    />
    <path
      d="M8.33333 9.16667C10.1743 9.16667 11.6667 7.67428 11.6667 5.83333C11.6667 3.99238 10.1743 2.5 8.33333 2.5C6.49238 2.5 5 3.99238 5 5.83333C5 7.67428 6.49238 9.16667 8.33333 9.16667Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.01667"
    />
  </svg>
);
